import { KeysTabsAnalysis, SetAnalysisPhase } from "@app/types/samples.types";
import Preparation from "../../components/analysisComponents/Ni63/preparation";
import {
  calculationMap,
  calculationMapBRBT,
  calculationMapDP,
  calculationMapSR,
  countingATMap,
  countingIodo131,
  countingMap,
  countingMapBRBT,
  measurementMap,
  measurementMapBRBT,
  preparationATMap,
  preparationIodo,
  preparationMap,
  preparationMapBRBT,
  preparationMapBPP,
  countingGTIG,
  calculationIG,
  calculationMapPuAmCM,
  calculationGT,
} from "../../utils/helpers";
import CountingCommon from "../../components/analysisComponents/commonForms/counting";
import CalculationCommon from "../../components/analysisComponents/commonForms/calculation";
import Measurement from "../../components/analysisComponents/Fe55/measurement";
import CountingFe55 from "../../components/analysisComponents/Fe55/counting";
import MeasurementNi63 from "../../components/analysisComponents/Ni63/measurement";
import PreparationAlfaTotal from "../../components/analysisComponents/alfaTotal/preparation";
import CountingAlfaTotal from "../../components/analysisComponents/alfaTotal/counting";
import CalculationAlfaTotal from "../../components/analysisComponents/alfaTotal/calculation";
import PreparationIodo131 from "../../components/analysisComponents/iodo131/preparation";
import CountingIodo131 from "../../components/analysisComponents/iodo131/counting";
import CalculationIodo131 from "../../components/analysisComponents/iodo131/calculation";
import PreparationDP from "../../components/analysisComponents/DP/preparation";
import CountingDP from "../../components/analysisComponents/DP/counting";
import PreparationVapor from "../../components/analysisComponents/tritio/tritioVapor/preparation/preparation";
import PreparationSR from "../../components/analysisComponents/SR/preparation";
import MeasurementSR from "../../components/analysisComponents/SR/measurement";
import CountingSR from "../../components/analysisComponents/SR/counting";
import CalculatioSR from "../../components/analysisComponents/SR/calculation";
import CalculationDP from "../../components/analysisComponents/DP/calculation";
import PreparationBRBT from "../../components/analysisComponents/BR/preparation-BR-BT";
import MeasurementBRBT from "../../components/analysisComponents/BR/measurement-BR-BT";
import CountingBRBT from "../../components/analysisComponents/BR/counting-BR-BT";
import CalculationBRBT from "../../components/analysisComponents/BR/calculation-BR-BT";
import PreparationBPP from "../../components/analysisComponents/BPP/preparation";
import CountingBPP from "../../components/analysisComponents/BPP/counting";
import CalculationBPP from "../../components/analysisComponents/BPP/calculation";
import PreparationGTIG from "../../components/analysisComponents/GT/preparation";
import CountigGTIG from "../../components/analysisComponents/GT/countig";
import CalculationIG from "../../components/analysisComponents/IG/calculation";
import PreparationPuAmCM from "../../components/analysisComponents/PuAmCM/preparation";
import CountingPuAmCM from "../../components/analysisComponents/PuAmCM/counting";
import CalculationPuAmCM from "../../components/analysisComponents/PuAmCM/calculation";
import CalculationGT from "../../components/analysisComponents/GT/calculation";

export const setsAnalysisPhasesTritioAgua: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: Preparation,
    functionMap: preparationMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingCommon,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationCommon,
    functionMap: calculationMap,
  },
];

export const setsAnalysisPhasesFe55: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: Preparation,
    functionMap: preparationMap,
  },
  {
    label: "Medidas de Fe por AA",
    set: "aa-measure",
    endpoint: "aa-measure",
    component: Measurement,
    functionMap: measurementMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingFe55,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationCommon,
    functionMap: calculationMap,
  },
];

export const setsAnalysisPhasesNi63: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: Preparation,
    functionMap: preparationMap,
  },
  {
    label: "Medidas de Ni por AA",
    set: "aa-measure",
    endpoint: "aa-measure",
    component: MeasurementNi63,
    functionMap: measurementMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingFe55,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationCommon,
    functionMap: calculationMap,
  },
];

export const setsAnalysisPhasesAlfaTotal: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationAlfaTotal,
    functionMap: preparationATMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingAlfaTotal,
    functionMap: countingATMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationAlfaTotal,
    functionMap: calculationMap,
  },
];

export const setsAnalysisPhasesIodo131: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationIodo131,
    functionMap: preparationIodo,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingIodo131,
    functionMap: countingIodo131,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationIodo131,
    functionMap: calculationMap,
  },
];

export const setsAnalysisPhasesDP: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationDP,
    functionMap: preparationMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingDP,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationDP,
    functionMap: calculationMapDP,
  },
];

export const setsAnalysisPhasesTritioVapor: {
  label: string;
  set: string;
  endpoint: string;
  component: React.ComponentType<any>;
  functionMap: (data: any) => any;
}[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationVapor,
    functionMap: preparationMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingCommon,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationCommon,
    functionMap: calculationMap,
  },
];

export const setsAnalysisPhasesSR: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationSR,
    functionMap: preparationMap,
  },
  {
    label: "Medidas de absorción",
    set: "aa-measure",
    endpoint: "aa-measure",
    component: MeasurementSR,
    functionMap: measurementMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingSR,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculatioSR,
    functionMap: calculationMapSR,
  },
];

export const setsAnalysisPhasesBR: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationBRBT,
    functionMap: preparationMapBRBT,
  },
  {
    label: "Medidas de absorción",
    set: "aa-measure",
    endpoint: "aa-measure",
    component: MeasurementBRBT,
    functionMap: measurementMapBRBT,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingBRBT,
    functionMap: countingMapBRBT,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationBRBT,
    functionMap: calculationMapBRBT,
  },
];

export const setsAnalysisPhasesBT: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationBRBT,
    functionMap: preparationMapBRBT,
  },
  {
    label: "Medidas de absorción",
    set: "aa-measure",
    endpoint: "aa-measure",
    component: MeasurementBRBT,
    functionMap: measurementMapBRBT,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingBRBT,
    functionMap: countingMapBRBT,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationBRBT,
    functionMap: calculationMapBRBT,
  },
];

export const setsAnalysisPhasesBPP: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationBPP,
    functionMap: preparationMapBPP,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingBPP,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationBPP,
    functionMap: calculationMap,
  },
];

export const setsAnalysisPhasesGT: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationGTIG,
    functionMap: preparationIodo,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountigGTIG,
    functionMap: countingGTIG,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationGT,
    functionMap: calculationGT,
  },
];

export const setsAnalysisPhasesIG: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationGTIG,
    functionMap: preparationIodo,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountigGTIG,
    functionMap: countingGTIG,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationIG,
    functionMap: calculationIG,
  },
];

export const setsAnalysisPhasesPuAmCM: SetAnalysisPhase[] = [
  {
    label: "Preparación",
    set: "preparation",
    endpoint: "preparation",
    component: PreparationPuAmCM,
    functionMap: preparationMap,
  },
  {
    label: "Contaje",
    set: "counting",
    endpoint: "counting",
    component: CountingPuAmCM,
    functionMap: countingMap,
  },
  {
    label: "Cálculos",
    set: "calculation",
    endpoint: "calculation",
    component: CalculationPuAmCM,
    functionMap: calculationMapPuAmCM,
  },
];

export const configFunctionMap = {
  [KeysTabsAnalysis.Ni63]: setsAnalysisPhasesNi63,
  [KeysTabsAnalysis.Fe55]: setsAnalysisPhasesFe55,
  [KeysTabsAnalysis.H3_A]: setsAnalysisPhasesTritioAgua,
  [KeysTabsAnalysis.H3_V]: setsAnalysisPhasesTritioVapor,
  [KeysTabsAnalysis.AT]: setsAnalysisPhasesAlfaTotal,
  [KeysTabsAnalysis.I131]: setsAnalysisPhasesIodo131,
  [KeysTabsAnalysis.DP]: setsAnalysisPhasesDP,
  [KeysTabsAnalysis.Sr89]: setsAnalysisPhasesSR,
  [KeysTabsAnalysis.Sr90]: setsAnalysisPhasesSR,
  [KeysTabsAnalysis.Sr89_90]: setsAnalysisPhasesSR,
  [KeysTabsAnalysis.BR]: setsAnalysisPhasesBR,
  [KeysTabsAnalysis.BT]: setsAnalysisPhasesBT,
  [KeysTabsAnalysis.BPP]: setsAnalysisPhasesBPP,
  [KeysTabsAnalysis.GT]: setsAnalysisPhasesGT,
  [KeysTabsAnalysis.IG]: setsAnalysisPhasesIG,
  [KeysTabsAnalysis.Pu238]: setsAnalysisPhasesPuAmCM,
  [KeysTabsAnalysis.Pu239_240]: setsAnalysisPhasesPuAmCM,
  [KeysTabsAnalysis.AM241]: setsAnalysisPhasesPuAmCM,
  [KeysTabsAnalysis.Cm243_244]: setsAnalysisPhasesPuAmCM,
};

// This const contains the configuration of the analysis phases of the samples
export const analysis_conditioning = [KeysTabsAnalysis.AT];

// This const contains the configuration of the aconditions in analysis phases of the samples
export const analysis_processing = [
  KeysTabsAnalysis.AT,
  KeysTabsAnalysis.I131,
  KeysTabsAnalysis.Pu238,
  KeysTabsAnalysis.Pu239_240,
  KeysTabsAnalysis.AM241,
  KeysTabsAnalysis.Cm243_244,
  KeysTabsAnalysis.IG,
  KeysTabsAnalysis.GT,
];

// This const contains the configuration of the proccesing in analysis phases of the samples
export const AnalysisWhitMeasurement = [
  KeysTabsAnalysis.Ni63,
  KeysTabsAnalysis.Fe55,
  KeysTabsAnalysis.Sr89,
  KeysTabsAnalysis.Sr90,
  KeysTabsAnalysis.Sr89_90,
  KeysTabsAnalysis.BR,
  KeysTabsAnalysis.BT,
];

// This const contains the configuration of the analysis with files in calculations

export const AnalysisWithFiles = [
  KeysTabsAnalysis.GT,
  KeysTabsAnalysis.IG,
  KeysTabsAnalysis.Pu238,
  KeysTabsAnalysis.Pu239_240,
  KeysTabsAnalysis.AM241,
  KeysTabsAnalysis.Cm243_244,
];

export const AnalysisNeedUpdateCounting = [
  KeysTabsAnalysis.GT,
  KeysTabsAnalysis.IG,
  KeysTabsAnalysis.Pu238,
  KeysTabsAnalysis.Pu239_240,
  KeysTabsAnalysis.AM241,
  KeysTabsAnalysis.Cm243_244,
];
